import { NgModule } from '@angular/core';
import { PStepComponent } from './p-step/p-step.component';
import { PStepperComponent } from './p-stepper/p-stepper.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PIconModule } from '@panaya/ui/p-icon';
import { PButtonModule } from '@panaya/ui/p-button';

@NgModule({
    declarations: [PStepComponent, PStepperComponent],
    imports: [CommonModule, TranslateModule, PIconModule, PButtonModule],
    exports: [PStepComponent, PStepperComponent]
})
export class PStepperModule {}
